module.exports = __webpack_public_path__ + "static/media/blackarrow.571cb30f.svg";